export default class {
  static key(key) {
    return `omja_bo_${key}`;
  }

  static get(key) {
    return localStorage.getItem(this.key(key));
  }

  static set(key, value) {
    return localStorage.setItem(this.key(key), value);
  }

  static delete(key) {
    return localStorage.removeItem(this.key(key));
  }
}
